import React from 'react'
import Header from './Header'
import Hero from './Hero'
import AboutUs from './About'
import Slider from './Slider'
import Testimonial from './Testimonial'
import Rating from'./Rating'
import Footer from './Footer'
import Contact from './Contact'

const Home = () => {
  return (
    <>
    <Header/>
    <Hero/>
    <AboutUs/>
    <Rating/>
    <Slider/>
    <Testimonial/>
    <Contact/>
    <Footer/>
    </>
  )
}

export default Home